import * as React from 'react'

export interface TimeLeft {
  days: number
  hours: number
  minutes: number
  seconds: number
  isComplete: boolean
}

function getTimeLeft(targetTime: number): TimeLeft {
  const diff = targetTime - Date.now()
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isComplete: true }
  }
  const totalSeconds = Math.floor(diff / 1000)
  return {
    days: Math.floor(totalSeconds / 86_400),
    hours: Math.floor((totalSeconds % 86_400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isComplete: false,
  }
}

/**
 * Ticks toward `target` every second, stopping at the deadline. `enabled: false`
 * skips the interval entirely (e.g. when the banner is dismissed).
 */
export function useCountdown(target: Date, enabled = true): TimeLeft {
  const targetTime = target.getTime()
  const [timeLeft, setTimeLeft] = React.useState(() => getTimeLeft(targetTime))

  React.useEffect(() => {
    if (!enabled) {
      return
    }
    // Resync immediately (covers a changed target and the gap since first paint).
    setTimeLeft(getTimeLeft(targetTime))
    const intervalId = setInterval(() => {
      const next = getTimeLeft(targetTime)
      setTimeLeft(next)
      if (next.isComplete) {
        clearInterval(intervalId)
      }
    }, 1000)
    return () => clearInterval(intervalId)
  }, [targetTime, enabled])

  return timeLeft
}
